export default function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}



// WEBPACK FOOTER //
// ./src/components/helpers/sleep.js